/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AppService } from 'src/app/api.service';
import { ToastrService } from 'ngx-toastr';
import { PopupService } from 'src/app/services/popup.service';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit{
  displayFeedback = false;
  feedbackForm:FormGroup;
  submitted = false;
  constructor(@Inject(PLATFORM_ID) private platformId: object,private fb:FormBuilder, public _as:AppService, private toastr:ToastrService,public _pop:PopupService,private _ac:ActivatedRoute){
    this.feedbackForm = this.fb.group({
      'full_name': new FormControl('',[Validators.required]),
      'mobile': new FormControl('',[Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]+$')]),
      'email': new FormControl('',[Validators.required, Validators.email]),
      'feedback': new FormControl('',[Validators.required]),
    })
  }

  ngOnInit(): void {
    // if(isPlatformBrowser(this.platformId)){
    this._ac.queryParams.subscribe((pra: any) => {
      if(pra.displayFeedback){
        setTimeout(() => {
          this.displayFeedback = pra.displayFeedback
          }, 1000);
        }
      })
    // }
  }

  get f(){
    return this.feedbackForm.controls;
  }

  feedbackSubmit(data:any){
   this.submitted = true;
   if(this.feedbackForm.valid){
    const url = this._as.api_base_url + 'renovarz/feedback/';
    this._as.postRequest(url, data, false).subscribe((res:any)=>{
      if(res){
        this.submitted = false;
        this.feedbackForm.reset();
        this.displayFeedback = false;
        this.toastr.success('Thank you for your feedback!')
      }
    })
   }
  }
}
